import React, { useState } from 'react';
import { connect } from 'react-redux';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import { postPatch } from '@/util/helpers/ajax-helpers';
import { closeReactModal, loadViewsData } from '../actions';
import ModalContent from './ModalContent';
import CategoryRef from '../util/CategoryRef';
import AjaxSpinner from './AjaxSpinner';

const modalEditCategory = (props) => {
  const { category, modalClosed, saveSuccessful } = props;

  const [tag, setTag] = useState(category);
  const [saving, setSaving] = useState(false);
  const [changed, setChanged] = useState(false);

  const onSaveButtonClicked = () => {
    setSaving(true);
    const toSave = new CategoryRef(tag.id(), tag.name().trim(), null);
    postPatch('updating category', `/categories/`, toSave)
      .then(() => {
        NotificationManager.success(
          `Category updated successfully!`,
          null,
          5000,
        );
        modalClosed();
        saveSuccessful();
      })
      .catch(() => {
        setSaving(false);
      });
  };

  const onTextFieldChange = (e) => {
    const updated = new CategoryRef(tag.id(), e.target.value, null);
    const original = tag.name();
    setTag(updated);
    setChanged(updated.name() !== original);
  };

  return (
    <ModalContent
      onClose={modalClosed}
      extraSmall
      header="Rename Category"
      onSubmit={onSaveButtonClicked}
      footer
      disabled={!changed}
    >
      {saving ? (
        <AjaxSpinner small center />
      ) : (
        <input
          id="tagNameTxt"
          key="insight-name"
          placeholder="Category name"
          className="form-control set-input-height "
          onChange={(event) => onTextFieldChange(event)}
          defaultValue={tag.name()}
          style={{ height: '45px' }}
          maxLength="40"
        />
      )}
    </ModalContent>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    modalClosed: () => {
      dispatch(closeReactModal());
    },
    saveSuccessful: () => {
      dispatch(loadViewsData()); // reload views data (needed, in particular, to update datasource.totalSavedViews)
    },
  };
};

export default connect(null, mapDispatchToProps)(modalEditCategory);
